import 'css-chunk:src/list/simpleList/simpleList.module.scss';export default {
  "heading-xxl": "simpleList-module__heading-xxl___kZEYK",
  "wrapper": "simpleList-module__wrapper___-Z8iJ",
  "heading-xl": "simpleList-module__heading-xl___4CPsM",
  "heading-lg": "simpleList-module__heading-lg___-X6-s",
  "heading-md": "simpleList-module__heading-md___H11Xr",
  "heading-sm": "simpleList-module__heading-sm___2TEoA",
  "heading-xs": "simpleList-module__heading-xs___x4FUI",
  "body-one": "simpleList-module__body-one___n-Wdv",
  "body-two": "simpleList-module__body-two___HYNET",
  "body-three": "simpleList-module__body-three___OHai9",
  "body-four": "simpleList-module__body-four___RJ86Q",
  "overline-one": "simpleList-module__overline-one___2s9B1",
  "overline-two": "simpleList-module__overline-two___UnULb",
  "overline-three": "simpleList-module__overline-three___T4216",
  "strong": "simpleList-module__strong___RqZw3",
  "em": "simpleList-module__em___OMAql",
  "figcaption": "simpleList-module__figcaption___DueL-",
  "no-margin": "simpleList-module__no-margin___DRe-j",
  "simpleList": "simpleList-module__simpleList___6m3Yo",
  "simpleListItem": "simpleList-module__simpleListItem___J9uUP",
  "simpleListItemIcon": "simpleList-module__simpleListItemIcon___9SpcX",
  "simpleListItemLabel": "simpleList-module__simpleListItemLabel___a9xkI",
  "simpleList-type-primary": "simpleList-module__simpleList-type-primary___B3-MV",
  "simpleList-type-secondary": "simpleList-module__simpleList-type-secondary___dBcnx",
  "simpleList-type-brand": "simpleList-module__simpleList-type-brand___mgJYz",
  "simpleList-size-l": "simpleList-module__simpleList-size-l___s-4U2",
  "simpleListItemBullet": "simpleList-module__simpleListItemBullet___v77sl",
  "simpleList-size-m": "simpleList-module__simpleList-size-m___HQJUq",
  "simpleList-size-s": "simpleList-module__simpleList-size-s___eAYTu",
  "simpleList-size-xs": "simpleList-module__simpleList-size-xs___QPvmM",
  "simpleList-weight-bold": "simpleList-module__simpleList-weight-bold___sbe1K"
};